import { render, staticRenderFns } from "./Examine.vue?vue&type=template&id=37b5c832&scoped=true&"
import script from "./Examine.vue?vue&type=script&lang=js&"
export * from "./Examine.vue?vue&type=script&lang=js&"
import style0 from "./Examine.vue?vue&type=style&index=0&id=37b5c832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b5c832",
  null
  
)

export default component.exports